module.exports = __webpack_public_path__ + "img/status-1.468e9dbe.png";